/**
 * Vanilla replacement for MooTools' `:relay` event delegation.
 */
export function delegate<K extends keyof HTMLElementEventMap>(
   root: Element | Document,
   type: K,
   selector: string,
   handler: (event: HTMLElementEventMap[K], matched: Element) => void,
   options?: AddEventListenerOptions
): void {
   root.addEventListener(
      type,
      event => {
         const { target } = event;
         if (!(target instanceof Element)) {
            return;
         }

         // closest() walks up past root, so an ancestor of root matching
         // selector would fire for events this container never owned.
         const matched = target.closest(selector);
         if (!matched || !root.contains(matched)) {
            return;
         }

         handler(event as HTMLElementEventMap[K], matched);
      },
      options
   );
}
